import './BlogDetail.css';
import MainDetail from './MainDetail';
import RecentBlog from './RecentBlog';
import { useParams } from "react-router-dom";
// import Comp2new from './Comp2new';
// import Comp3 from './Comp3';

function BlogDetail() {
  const { slug } = useParams();
  return (
    <div className="BlogDetail">
      <div className='comp-main'>
          <div className='first'>
            <MainDetail slug={slug}/>
          </div>
          <div className='second'>
          <RecentBlog slug={slug} />
          </div>
      </div>  
    </div>
  );
}

export default BlogDetail;
